<template>
  <v-main class="font-weight-medium">
    <div class="d-flex flex-column justify-center align-center px-3 geeks with-background">
      <div
        class="d-flex flex-column overflow-hidden"
        style="width: 350px; max-width: 350px; min-width: 350px; height: 600px; min-height: 600px;"
      >
        <div class="flex-none">
          <div class="d-flex flex-column align-center">
            <v-progress-circular
              :indeterminate="progressData.indeterminate"
              :value="progressData.value"
              :color="progressData.color"
              :size="150"
              :width="8"
            >
              <v-icon
                :size="100"
                :color="progressData.color"
              >{{ progressData.icon }}</v-icon>
            </v-progress-circular>
          </div>
          <v-divider class="my-6"></v-divider>
        </div>
        <div class="flex-grow-1 flex-shrink-0">
          <div class="px-3">
            <p v-for="(line, i) of body" :key="i">{{ line }}</p>
          </div>
        </div>
        <div class="flex-none">
          <v-divider class="mt-6"></v-divider>
          <div class="px-3">
            <span>{{ $t('APP_TITLE') }}</span>
          </div>
          <div class="d-flex justify-end pb-12 pr-3">
            <CPULogo :height="30" fill="white"/>
          </div>
        </div>
      </div>
    </div>
  </v-main>
</template>

<script>
import CPULogo from '@/components/common/CPULogo.vue'
import { msalInstance, logOut } from '@/libs/Auth'
import {
  mdiShieldOutline,
  mdiAccountCheckOutline,
  mdiAccountSyncOutline,
  mdiExclamation,
  mdiCheck,
  mdiHelp
} from '@mdi/js'
export default {
  name: 'AccountStatus',
  components: {
    CPULogo
  },
  props: {
    name: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: 'OK'
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
  }),
  computed: {
    body () {
      const name = this.name ? ` ${this.name}` : ''
      return this.$t(this.status, { name }).split('\n')
    },
    progressData () {
      let color
      let icon
      let indeterminate
      let value
      switch (this.status) {
        case 'AUTHENTICATION':
          icon = mdiShieldOutline
          color = 'primary'
          indeterminate = true
          value = null
          break
        case 'FEATURES_UNAVAILABLE':
          icon = mdiAccountCheckOutline
          color = 'success'
          indeterminate = false
          value = 100
          break
        case 'CREATION_PENDING':
          icon = mdiAccountSyncOutline
          color = 'primary'
          indeterminate = true
          value = null
          break
        case 'ACCESS_UNDEFINED':
        case 'PROFILE_NOT_FOUND':
          icon = mdiExclamation
          color = 'error'
          indeterminate = false
          value = 100
          break
        case 'MISSING_INFO':
          icon = mdiHelp
          color = 'warning'
          indeterminate = false
          value = 100
          break
        default:
          icon = mdiCheck
          color = 'success'
          indeterminate = false
          value = 100
          break
      }
      return { color, icon, indeterminate, value }
    }
  },
  methods: {
    onTryAgain () {
      msalInstance.browserStorage.clear()
      msalInstance.loginRedirect({
        scopes: ['openid', 'User.Read', 'email'],
        prompt: 'login',
        redirectUri: new URL('', window.location.origin).toString()
      })
    },
    signOut () {
      logOut()
    }
  }
}
</script>

<style>
.geeks {
  width: 100%;
  height: 100%;
}
</style>

<i18n>
{
  "fr": {
    "AUTHENTICATION": "Bonjour{name},\nAuthentification en cours. Patientez s'il vous plaît..\nMERCI.",
    "FEATURES_UNAVAILABLE": "Bonjour{name},\nVotre compte a été créé et vous serez averti lorsque les fonctionnalités seront disponibles.\nMERCI.",
    "CREATION_PENDING": "Bonjour{name},\nVotre compte est en cours de création. Vous serez automatiquement dirigé vers l'acceuil une fois cette étape complétée.\nMERCI.",
    "ACCESS_UNDEFINED": "Bonjour{name}\nIl nous est impossible de déterminer votre droit d'accès a cette application.\nS.V.P. Communiquer le contenu de ce message au support CPU pour corriger la situation.\nMERCI.",
    "MISSING_INFO": "Bonjour{name}\nVotre compte est créé mais le nom de compagnie est manquant.\nS.V.P. Communiquer le contenu de ce message au support CPU pour corriger la situation.\nMERCI.",
    "PROFILE_NOT_FOUND": "Bonjour{name}\nNous somme dans l'incapacité de charger votre profil car celui-ci n'existe pas.\nS.V.P. Communiquer le contenu de ce message au support CPU pour corriger la situation.\nMERCI.",
    "BTN_LABEL": "nouveau login",
    "LOGOUT": "Déconnexion"
  },
  "en": {
    "AUTHENTICATION": "Hello{name},\nAuthentication in progress. Hang on please...\nTHANK YOU.",
    "FEATURES_UNAVAILABLE": "Hello{name},\nYour account has been created and you will be notified when features become available.\nTHANKS.",
    "CREATION_PENDING": "Hello{name},\nYour account is being created. You will be automatically directed to the home page once this step is completed.\nTHANK YOU.",
    "ACCESS_UNDEFINED": "Hello{name}\nIt is impossible for us to determine your access rights to this application.\nPlease communicate the content of this message to CPU support to correct the situation.\nTHANK YOU.",
    "MISSING_INFO": "Hello{name}\nYour account is created but the company name is missing.\nPlease communicate the content of this message to CPU support to correct the situation.\nTHANK YOU.",
    "PROFILE_NOT_FOUND": "Hello{name}\nWe are unable to load your profile because it does not exist.\nPlease communicate the content of this message to CPU support to correct the situation.\nTHANK YOU.",
    "BTN_LABEL": "new login",
    "LOGOUT": "Logout"
  }
}
</i18n>
